import request, { METHODS } from "src/utils/api-base";

const supplierApis = {
  createSupplier: (payload: any) => {
    return request({
      route: "/app/suppliers",
      method: METHODS.POST,
      payload,
      auth: true,
    });
  },

  getSupplierList: (params: {
    page: number;
    limit: number;
    status?: "active" | "inactive";
    search?: string;
  }) => {
    return request({
      route: "/app/suppliers",
      method: METHODS.GET,
      params,
      auth: true,
    });
  },

  editSupplier: (payload: any) => {
    return request({
      route: `/app/suppliers/${payload._id}`,
      method: METHODS.PUT,
      payload,
      auth: true,
    });
  },
  getSupplierDetails: (id: string) =>
    request({
      route: `/app/suppliers/${id}`,
      method: METHODS.GET,
      auth: true,
    }),

  // Bulk-create suppliers from parsed spreadsheet rows
  bulkImport: (rows: Array<Record<string, any>>) => {
    return request({
      route: "/app/suppliers/bulk-import",
      method: METHODS.POST,
      payload: { rows },
      auth: true,
    });
  },
};

export default supplierApis;
